export default "__VITE_ASSET__Cv5cMask__"